import { observable, action } from 'mobx';
import axios from 'axios/index';
import { Common as util } from '../utils/common';
import gql from '../utils/gql';

/**
 * 카페24 webhook 모니터링 store (슈퍼어드민 전용)
 * 백엔드: api/query.js getWebhookStats/Trend/EventBreakdown/StoreBreakdown/RecentFailedWebhooks/Logs/Detail
 *         api/mutation/webhookMutation.js retryWebhook/resetWebhookLogs
 */
export class Webhook {

  @observable isLoading = false;
  @observable stats = null;
  @observable trend = [];
  @observable eventBreakdown = [];
  @observable storeBreakdown = [];
  @observable recentFailed = [];

  _query = (operation, properties, getData) => (data, cb) => {
    const variables = util.getDataStByKey(data, properties);
    const params = { type: 'query', operation, variables, getData };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        if (res.status === 200) {
          const d = res.data.data[operation];
          if (typeof cb === 'function') cb(d);
          else return d;
        }
      })
      .catch(err => {
        console.log(err);
        if (typeof cb === 'function') cb(null);
        return err;
      });
  };

  _mutation = (operation, properties, getData) => (data, cb) => {
    const variables = util.getDataStByKey(data, properties);
    const params = { type: 'mutation', operation, variables, getData };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = (res.data && res.data.data) ? res.data.data[operation] : null;
        const errors = (res.data && res.data.errors) ? res.data.errors : null;
        if (typeof cb === 'function') cb(result, errors);
        else return result;
      })
      .catch(err => {
        if (typeof cb === 'function') cb(null, err);
        return err;
      });
  };

  @action getWebhookStats = this._query(
    'getWebhookStats',
    ['startDate', 'endDate', 'store_id', 'mall_id'],
    'data'
  );

  @action getWebhookTrend = this._query(
    'getWebhookTrend',
    ['startDate', 'endDate', 'granularity', 'store_id', 'mall_id'],
    'data'
  );

  @action getWebhookEventBreakdown = this._query(
    'getWebhookEventBreakdown',
    ['startDate', 'endDate', 'store_id', 'mall_id', 'limit'],
    'data'
  );

  @action getWebhookStoreBreakdown = this._query(
    'getWebhookStoreBreakdown',
    ['startDate', 'endDate', 'limit'],
    'data'
  );

  @action getRecentFailedWebhooks = this._query(
    'getRecentFailedWebhooks',
    ['startDate', 'endDate', 'store_id', 'mall_id', 'status', 'limit'],
    'data'
  );

  @action getWebhookLogs = this._query(
    'getWebhookLogs',
    ['page', 'limit', 'sort', 'searchParams'],
    'docs, totalDocs, totalPages, page, limit, hasPrevPage, hasNextPage'
  );

  @action getWebhookLogDetail = this._query(
    'getWebhookLogDetail',
    ['_id'],
    'data'
  );

  @action getWebhookCoverage = this._query(
    'getWebhookCoverage',
    ['startDate', 'endDate'],
    'data'
  );

  @action retryWebhook = this._mutation(
    'retryWebhook',
    ['_id'],
    'data'
  );

  @action resetWebhookLogs = this._mutation(
    'resetWebhookLogs',
    ['startDate', 'endDate', 'status'],
    'data'
  );
}
